import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Space, Tag } from 'antd';
import { ArrowLeftOutlined, ApiOutlined, SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from '../../context/ThemeContext';
import { ROUTES } from '../../constants/routes';

export default function ApiNav() {
    const navigate = useNavigate();
    const { isDark, toggleMode } = useTheme();

    return (
        <header className="api-nav">
            <div className="api-nav__inner" dir="ltr">
                <div className="api-nav__left">
                    <button type="button" className="api-nav__brand" onClick={() => navigate(ROUTES.HOME)}>
                        SOHO<span>CARD</span>
                    </button>
                    <Tag className="api-nav__badge" bordered={false}>
                        <ApiOutlined /> API
                    </Tag>
                </div>

                <Space size={8} className="api-nav__right">
                    <Button
                        type="text"
                        size="large"
                        icon={isDark ? <SunOutlined /> : <MoonOutlined />}
                        onClick={toggleMode}
                        aria-label="Toggle theme"
                    />
                    <Link to={ROUTES.HOME}>
                        <Button type="text" icon={<ArrowLeftOutlined />}>
                            Back to site
                        </Button>
                    </Link>
                </Space>
            </div>
        </header>
    );
}